import { DataTable } from "primereact/datatable";
import { WithdrawalRequest } from "../../../../Transfer/models/transfer.model";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { Column } from "primereact/column";

interface Props {
  actuallyDataWithdrawalResponse: WithdrawalRequest[];
}

function TableActuallyWithdrawalRequest({
  actuallyDataWithdrawalResponse,
}: Props): JSX.Element {
  const [globalFilter, setGlobalFilter] = useState<string | null>(null);

  const headerSearch = (
    <div className="flex justify-content-end w-full pb-2">
      <InputText
        style={{ width: "200px" }}
        type="text"
        placeholder="Buscar en historial..."
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setGlobalFilter(e.target.value);
        }}
      />
    </div>
  );

  return (
    <div>
      <DataTable
        value={actuallyDataWithdrawalResponse}
        resizableColumns
        showGridlines
        tableStyle={{ minWidth: "100%" }}
        emptyMessage="No hay respuestas previas registradas"
        globalFilter={globalFilter}
        header={headerSearch}
        paginator={actuallyDataWithdrawalResponse.length > 5}
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
      >
        <Column field="idWithdrawalRequest" header="ID" style={{ width: "10%" }} />
        <Column field="dateWithdrawalRequest" header="Fecha solicitud" />
        <Column field="responseWithdrawalRequest" header="Respuesta" />
        <Column field="dateResponse" header="Fecha respuesta" />
      </DataTable>
    </div>
  );
}

export default TableActuallyWithdrawalRequest;